module.exports = __webpack_public_path__ + "media/images/emblems/Huettikon-blazon-a26045eb431ed02bb4f97b5665cc91cf.svg";